module.exports = __webpack_public_path__ + "external.d4e276714d0b5db107d55c4422ec5672.svg";